import moment from "moment"
import { Button, Card, CardMedia, Grid, Typography } from "@mui/material"
import { postCreateOrder, ServiceType } from "../../../services/ntuc/memberService/payment"
import { getRecurringPayment } from "../../../services/ntuc/paymentService/payment"
import { AppCookies } from "../../../helpers/cookies"
import { DeviceType } from "../../../services/ntuc/memberService/oaMembership"
import { useTranslation } from "react-i18next"
import recurringPaymentBanner from "../../../assets/recurringPaymentBanner.svg"

const RecurringPaymentPage = () => {
    const {t} = useTranslation(`recurring-payment`)
    const redirectToPaymentGateway = (clientOrderId: string) => {
        window.location.replace(getRecurringPayment(clientOrderId))
    }

    const handlePaymentButton = () => {
        let membershipId: number

        if (window.myNtucConfig.membershipId) {
            membershipId = parseInt(window.myNtucConfig.membershipId)
        } else {
            membershipId = sessionStorage[AppCookies.MEMBERSHIP_ID]
        }
        const order = {
            endDate: moment().toISOString(),
            startDate: moment().toISOString(),
            serviceType: ServiceType.CHANGE_MODE,
            noOfMonths: 0,
            amount: 0 + ``,
            isOneTimePayment: false,
            isRecurringPayment: true,
            membershipId: membershipId,
            deviceType: DeviceType.WEB,
        }
        postCreateOrder(order)
            .then(response => response.data.content.clientOrderId)
            .then(redirectToPaymentGateway)
            .catch(error => error.response.data.content)
            .then(console.error)
    }

    return (
        <Grid
            container
            rowSpacing={ 2 }
            padding={ 6 }
            columnSpacing={ {
                xs: `16px`,
                sm: `24px`,
                md: `24px`,
                lg: `40px`,
            } }>
            <Grid item md={ 12 } lg={ 12 } xs={ 12 } sm={ 12 } paddingBottom={ 1 }>
                <Card sx={ {border: `none`, boxShadow: `none`} }>
                    <CardMedia
                        sx={ {width: `40%`, objectFit: `contain`, marginLeft: `auto`, marginRight: `auto`, marginTop: `1vh`} }
                        component="img"
                        image={ recurringPaymentBanner }
                        alt="warning"
                    />
                </Card>
            </Grid>
            <Grid item md={ 12 } lg={ 12 } xs={ 12 } sm={ 12 } paddingBottom={ 1 }>
                <Typography align="center" variant="h5">{ t(`title`) }</Typography>
            </Grid>
            <Grid item md={ 12 } lg={ 12 } xs={ 12 } sm={ 12 }>
                <Typography align="center" variant="body1" color="text.secondary">{ t(`content`) }</Typography>
            </Grid>
            <Grid
                container
                justifyContent="space-evenly"
                alignItems="center"
                paddingTop={ 5 }>
                <Button variant="contained" color="primary" size="large" onClick={ handlePaymentButton }>
                    { t(`proceedToPayment`) }
                </Button>
            </Grid>
        </Grid>
    )
}

export default RecurringPaymentPage